import { GetTimeFromTimestamp, TextTemplateTagResponseObject, UglImportTask } from '@dave/types';


export class  TextTemplateTagEntity {
    constructor(
        public Id: number = null,
        public Text: string = null,
        public PartnerId: number = null,
        public UpdatedAt: Date = null,
        public CreatedAt: Date = null,
    ) {}

    public static EntityName = 'TextTemplateTagEntity';
    public Clone(override: Partial<TextTemplateTagEntity> = {}): TextTemplateTagEntity {
        const attr = { ...this, ...override };
        return Object.assign(new TextTemplateTagEntity(), attr);
    }
}

export function TextTemplateTagEntityFromBackend(res: TextTemplateTagResponseObject): TextTemplateTagEntity {

    return new TextTemplateTagEntity(
        res.Id && +res.Id,
        res.Text,
        res.PartnerId && +res.PartnerId,
        res.UpdatedAt && GetTimeFromTimestamp(+res.UpdatedAt),
        res.CreatedAt && GetTimeFromTimestamp(+res.CreatedAt),
    );
}
